/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsReferrals204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsReferrals505Schema = z.any();

export const optionsReferralsMutationResponseSchema = z.lazy(() => optionsReferrals204Schema);
